import Vue from 'vue';
import i18n from 'common-module/src/lang';
import store from '@/store';

let automationPromise: Promise<any> | null = null;

const loadAutomation = () => {
  if (!automationPromise) {
    automationPromise = new Promise((resolve, reject) => {
      import('automation').then((module) => {
        Vue.use(module.default, {
          i18n,
          store
        });
        resolve({
          Automation: module.default,
          ...module
        });
      }).catch((err) => {
        reject(err);
      });
    });
  }
  return automationPromise;
};

Vue.component('AutomationDetail', () => {
  return loadAutomation().then((module) => module.SmartAssistantDetail);
});

Vue.component('ShareSmartAssistantDialog', () => {
  return loadAutomation().then((module) => module.ShareSmartAssistantDialog);
});

Vue.component('ShareSmartAssistantDetail', () => {
  return loadAutomation().then((module) => module.ShareSmartAssistantDetail);
});
